(function () {
  function init(root) {
    if (root._smPdfInit) return;
    root._smPdfInit = true;

    var dataEl = root.querySelector('[data-sm-pdf-data]');
    var modal = root.querySelector('[data-sm-pdf-modal]');
    if (!dataEl || !modal) return;

    var slides = [];
    try { slides = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
    if (!slides.length) return;

    var titleEl = modal.querySelector('[data-sm-pdf-title]');
    var mediaEl = modal.querySelector('[data-sm-pdf-media]');
    var descEl = modal.querySelector('[data-sm-pdf-description]');
    var dotsEl = modal.querySelector('[data-sm-pdf-dots]');
    var prevBtn = modal.querySelector('[data-sm-pdf-prev]');
    var nextBtn = modal.querySelector('[data-sm-pdf-next]');
    var closeEls = modal.querySelectorAll('[data-sm-pdf-close]');

    // Build dots
    dotsEl.innerHTML = '';
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'sm-pdf-modal__dot';
      d.setAttribute('aria-label', 'Slide ' + (i + 1));
      d.addEventListener('click', function () { show(i); });
      dotsEl.appendChild(d);
    });

    var current = -1;
    var lastFocused = null;
    var mediaTrack = null;
    var descTrack = null;

    function buildTracks() {
      mediaEl.innerHTML = '';
      descEl.innerHTML = '';
      mediaEl.classList.add('sm-pdf-modal__viewport');
      descEl.classList.add('sm-pdf-modal__viewport');
      mediaTrack = document.createElement('div');
      mediaTrack.className = 'sm-pdf-modal__track';
      descTrack = document.createElement('div');
      descTrack.className = 'sm-pdf-modal__track sm-pdf-modal__track--desc';
      slides.forEach(function (s) {
        var ms = document.createElement('div');
        ms.className = 'sm-pdf-modal__slide sm-pdf-modal__slide--media';
        if (s.type) ms.setAttribute('data-tone', s.type);
        var isVideo = typeof s.src === 'string' && /\.(mp4|webm)(\?|#|$)/i.test(s.src);
        if (isVideo) {
          ms.classList.add('is-video');
          var v = document.createElement('video');
          v.src = s.src;
          v.autoplay = true; v.loop = true; v.muted = true; v.defaultMuted = true;
          v.playsInline = true;
          v.setAttribute('autoplay', ''); v.setAttribute('loop', '');
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
          ms.appendChild(v);
        } else if (s.src) {
          var img = document.createElement('img');
          img.src = s.src; img.alt = s.title || '';
          ms.appendChild(img);
        }
        mediaTrack.appendChild(ms);

        var ds = document.createElement('div');
        ds.className = 'sm-pdf-modal__slide sm-pdf-modal__slide--desc';
        ds.textContent = s.description || '';
        descTrack.appendChild(ds);
      });
      mediaEl.appendChild(mediaTrack);
      descEl.appendChild(descTrack);
    }

    function applyOffset(extraPx) {
      var pct = -current * 100;
      var px = extraPx || 0;
      mediaTrack.style.transform = 'translateX(calc(' + pct + '% + ' + px + 'px))';
      descTrack.style.transform = 'translateX(calc(' + pct + '% + ' + px + 'px))';
    }

    function render(i) {
      var slide = slides[i];
      if (modal) modal.setAttribute('data-modal-tone', slide.type || '');
      if (slide.type === 'ai') {
        var aiIcon = '<span class="sm-pdf-modal__ai-icon" aria-hidden="true"><svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.795 2.98047L25.1414 17.4162L39.59 22.7579L25.1414 28.0996L19.795 42.5354L14.4485 28.0996L0 22.7579L14.4485 17.4162L19.795 2.98047Z" fill="url(#sm-pdf-ai-g1-modal)"/><path d="M37.1153 0L39.2539 5.7743L45.0333 7.91098L39.2539 10.0477L37.1153 15.822L34.9767 10.0477L29.1973 7.91098L34.9767 5.7743L37.1153 0Z" fill="url(#sm-pdf-ai-g2-modal)"/><path d="M39.5899 32.1797L41.7285 37.954L47.5079 40.0907L41.7285 42.2274L39.5899 48.0016L37.4513 42.2274L31.6719 40.0907L37.4513 37.954L39.5899 32.1797Z" fill="url(#sm-pdf-ai-g3-modal)"/><defs><linearGradient id="sm-pdf-ai-g1-modal" x1="19.795" y1="2.98047" x2="19.795" y2="42.5354" gradientUnits="userSpaceOnUse"><stop stop-color="#94BAF9"/><stop offset="1" stop-color="#4175DE"/></linearGradient><linearGradient id="sm-pdf-ai-g2-modal" x1="37.1153" y1="0" x2="37.1153" y2="15.822" gradientUnits="userSpaceOnUse"><stop stop-color="#94BAF9"/><stop offset="1" stop-color="#4175DE"/></linearGradient><linearGradient id="sm-pdf-ai-g3-modal" x1="39.5899" y1="32.1797" x2="39.5899" y2="48.0016" gradientUnits="userSpaceOnUse"><stop stop-color="#94BAF9"/><stop offset="1" stop-color="#4175DE"/></linearGradient></defs></svg></span>';
        var aiText = '<span class="sm-pdf-card__label-ai-text">AI</span>';
        var titleText = slide.title || '';
        titleEl.innerHTML = titleText.replace('AI', aiIcon + aiText);
      } else {
        titleEl.textContent = slide.title || '';
      }
      applyOffset(0);
      dotsEl.querySelectorAll('.sm-pdf-modal__dot').forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
      // Play video on the active slide, pause others
      if (mediaTrack) {
        mediaTrack.querySelectorAll('.sm-pdf-modal__slide--media').forEach(function (sl, idx) {
          var vid = sl.querySelector('video');
          if (!vid) return;
          if (idx === i) { try { vid.currentTime = 0; vid.play(); } catch (e) {} }
          else { try { vid.pause(); } catch (e) {} }
        });
      }
    }

    function show(i) {
      if (i < 0) i = 0;
      if (i >= slides.length) i = slides.length - 1;
      current = i;
      render(i);
      updateNav();
    }

    function updateNav() {
      if (prevBtn) prevBtn.toggleAttribute('disabled', current <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', current >= slides.length - 1);
    }

    function open(i) {
      lastFocused = document.activeElement;
      modal.hidden = false;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      if (sbw > 0) document.documentElement.style.paddingRight = sbw + 'px';
      if (!mediaTrack) buildTracks();
      show(i);
    }

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      if (mediaTrack) {
        mediaTrack.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      }
      if (lastFocused && lastFocused.focus) {
        try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
      }
    }

    // Card click → open
    root.querySelectorAll('[data-sm-pdf-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.getAttribute('data-sm-pdf-index'), 10) || 0;
        open(idx);
      });
    });

    // Grid prev/next buttons
    var grid = root.querySelector('.sm-pdf-feature__grid');
    var gridPrev = root.querySelector('[data-sm-pdf-grid-prev]');
    var gridNext = root.querySelector('[data-sm-pdf-grid-next]');
    function getStep() {
      var card = grid && grid.querySelector('.sm-pdf-card');
      if (!card) return grid ? grid.clientWidth : 0;
      var s = window.getComputedStyle(grid);
      var gap = parseFloat(s.columnGap || s.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    var gridNavMax = Infinity;
    var gridNavRaf = 0;
    var gridNavDirty = true;
    function updateGridNav() {
      if (!grid || !gridPrev || !gridNext) return;
      if (gridNavDirty) {
        // lazy measure: only forces layout after load/idle or on real user scroll,
        // never during initial page construction
        gridNavMax = grid.scrollWidth - grid.clientWidth - 1;
        gridNavDirty = false;
      }
      var left = grid.scrollLeft;
      gridPrev.toggleAttribute('disabled', left <= 0);
      gridNext.toggleAttribute('disabled', left >= gridNavMax);
    }
    function scheduleGridNav() {
      if (gridNavRaf) return;
      gridNavRaf = requestAnimationFrame(function () {
        gridNavRaf = 0;
        updateGridNav();
      });
    }
    if (grid) {
      if (gridPrev) gridPrev.toggleAttribute('disabled', true);
      if (gridNext) gridNext.toggleAttribute('disabled', false);
      grid.addEventListener('scroll', scheduleGridNav, { passive: true });
      window.addEventListener('resize', function () {
        gridNavDirty = true;
        scheduleGridNav();
      });
      var idle = window.requestIdleCallback || window.setTimeout;
      if (document.readyState === 'complete') {
        idle(scheduleGridNav);
      } else {
        window.addEventListener('load', function () { idle(scheduleGridNav); });
      }
    }
    if (gridPrev) gridPrev.addEventListener('click', function () {
      grid.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    if (gridNext) gridNext.addEventListener('click', function () {
      grid.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    // Drag-to-scroll on grid (mirrors sm-pricing)
    if (grid) {
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      grid.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        if (e.target.closest('a, input, select, textarea, [role="button"]')) return;
        if (!e.target.closest('.sm-pdf-card')) return;
        isDown = true; moved = false;
        startX = e.pageX - grid.offsetLeft;
        startScroll = grid.scrollLeft;
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - grid.offsetLeft;
        var walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 4) {
          if (!moved) grid.classList.add('is-dragging');
          moved = true;
          e.preventDefault();
          grid.scrollLeft = startScroll - walk;
        }
      });
      document.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('is-dragging');
      });
      grid.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }

    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    prevBtn.addEventListener('click', function () { show(current - 1); });
    nextBtn.addEventListener('click', function () { show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    // Drag/swipe on modal content area to change slide (carousel-style)
    function attachSwipe(viewport) {
      if (!viewport) return;
      var startX = 0, startY = 0, isDown = false, locked = false;
      var THRESHOLD = 0.15; // 15% of viewport width

      function down(x, y) {
        isDown = true; locked = false; startX = x; startY = y;
        if (mediaTrack) mediaTrack.classList.add('is-swiping');
        if (descTrack) descTrack.classList.add('is-swiping');
      }
      function move(x, y) {
        if (!isDown) return false;
        var dx = x - startX;
        var dy = y - startY;
        if (!locked) {
          if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) locked = true;
          else if (Math.abs(dy) > 10) { isDown = false; cleanup(); return false; }
        }
        if (locked) {
          if (current <= 0 && dx > 0) dx = 0;
          if (current >= slides.length - 1 && dx < 0) dx = 0;
          applyOffset(dx);
          return true;
        }
        return false;
      }
      function cleanup() {
        if (mediaTrack) mediaTrack.classList.remove('is-swiping');
        if (descTrack) descTrack.classList.remove('is-swiping');
      }
      function up(x) {
        if (!isDown) return;
        isDown = false;
        var dx = x - startX;
        var width = viewport.getBoundingClientRect().width || 1;
        cleanup();
        if (locked && Math.abs(dx) / width > THRESHOLD) {
          if (dx < 0) show(current + 1);
          else show(current - 1);
        } else {
          applyOffset(0);
        }
        locked = false;
      }

      viewport.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        if (e.target.closest('button, a, input, [role="button"]')) return;
        down(e.clientX, e.clientY);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        if (move(e.clientX, e.clientY)) e.preventDefault();
      });
      document.addEventListener('mouseup', function (e) { up(e.clientX); });
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        down(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!e.touches.length) return;
        if (move(e.touches[0].clientX, e.touches[0].clientY)) {
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });
      viewport.addEventListener('touchend', function (e) {
        var t = e.changedTouches && e.changedTouches[0];
        if (t) up(t.clientX);
      });
    }

    attachSwipe(mediaEl);
    attachSwipe(descEl);
  }

  function bootstrap() {
    document.querySelectorAll('[data-sm-pdf-feature]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
